"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perror = void 0;
var IRError_1 = require("../../IR/IRNodes/IRError.js");
var Term_1 = require("../Term/index.js");
function perror(type, msg, addInfos) {
    var _a, _b;
    if (msg === void 0) { msg = undefined; }
    if (addInfos === void 0) { addInfos = {}; }
    addInfos =
        typeof addInfos === "object" &&
            addInfos !== null ?
            addInfos :
            { __original__: addInfos };
    var src = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split("\n")[2];
    src = src === null || src === void 0 ? void 0 : src.slice((_b = src.indexOf("at ") + 3) !== null && _b !== void 0 ? _b : 0);
    addInfos.__src__ = src;
    return new Term_1.Term(type, function (_dbn) { return new IRError_1.IRError(msg, addInfos); });
}
exports.perror = perror;
